import { EnvironmentInjector, inject, Injectable, InjectionToken } from '@angular/core';
import { IEnvironment } from '../environment.base';

export const APP_ENV = new InjectionToken<IEnvironment>('APP_ENV');

@Injectable({
  providedIn: 'root'
})
export class EnvironmentsService {
  private injector = inject(EnvironmentInjector);

  get environment(): IEnvironment {
    return this.injector.get<IEnvironment>(APP_ENV);
  }
}
